<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                      

                    <!-- Row -->
                    <div class="row">
                        <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                            <!-- Dashboard Box -->
                            <div class="col-xl-12">
                                <div class="dashboard-box margin-top-0">

                                    <!-- Headline -->
                                    <div class="headline">
                                        <h3><i class="material-icons">info</i> Informações gerais</h3>
                                    </div>

                                    <div class="content with-padding padding-bottom-0">

                                        <div class="row">

                                            <div class="col-xl-12 margin-bottom-20" v-if="form.atualizadoPor">
                                                Última modificação realizada em <strong style="color: #000">{{form.atualizacao | formatDate}}</strong> por <strong style="color: #000">{{form.atualizadoPor.nome}}</strong>.
                                            </div>


                                            <div v-bind:class="{'disabled': ($root.user.tipo == 'prestador' && form.id)}" class="col-lg-12 margin-bottom-20" >
                                                <div class="checkbox " style="border: 2px solid red; border-radius: 6px; padding-top: 10px; padding-left: 10px; padding-right: 10px;">
                                                    <input type="checkbox" :disabled="($root.user.tipo == 'prestador' && form.id)" id="suspenso" v-model="form.suspenso" true-value="1" false-value="0">
                                                    <label for="suspenso" style="color: red; line-height: 120%; padding-bottom: 5px;"><span class="checkbox-icon"></span> Cliente suspenso. Apenas pagamento antecipado a vista.</label>
                                                </div>
                                            </div>

                                            <div v-bind:class="{'disabled': ($root.user.tipo == 'prestador' && form.id)}" class="col-lg-12 margin-bottom-20" >
                                                <div class="checkbox " style="border: 2px solid red; border-radius: 6px; padding-top: 10px; padding-left: 10px; padding-right: 10px;">
                                                    <input type="checkbox" :disabled="($root.user.tipo == 'prestador' && form.id)" id="dividas" v-model="form.dividas" true-value="1" false-value="0">
                                                    <label for="dividas" style="color: red; line-height: 120%; padding-bottom: 5px;"><span class="checkbox-icon"></span> Faturamento não aprovado, apenas PIX ou pagamento a vista.</label>
                                                </div>
                                            </div>                                            

                                            <div class="col-xl-12 margin-bottom-20">
                                                <div class="submit-field margin-bottom-0 padding-bottom-0">
                                                    <h5>Tipo do cadastro:</h5>
                                                </div>         

                                                <div class="radio">
                                                    <input id="radio-2" name="radio" type="radio" v-model="form.tipo" value="Pessoa Jurídica">
                                                    <label for="radio-2"><span class="radio-label"></span> Pessoa Jurídica</label>
                                                </div>                                                                                                                                             
                                                <div class="radio margin-left-20">
                                                    <input id="radio-1" name="radio" type="radio" v-model="form.tipo" value="Pessoa Física">
                                                    <label for="radio-1"><span class="radio-label"></span> Pessoa Física</label>
                                                </div>

                                            </div>

                                            <div class="col-xl-4 col-xs-10 col-md-5 col-lg-5" v-if="form.tipo == 'Pessoa Jurídica'">
                                                <div class="submit-field">
                                                    <h5>CNPJ:</h5>
                                                    <the-mask :mask="['##.###.###/####-##']" class="with-border" type="tel" v-model="form.doc" placeholder="__.___.___/____-__" />
                                                </div>
                                            </div>

                                            <div class="col-xl-4 col-xs-10 col-md-5 col-lg-5" v-if="form.tipo == 'Pessoa Física'">
                                                <div class="submit-field">
                                                    <h5>CPF:</h5>
                                                    <the-mask :mask="['###.###.###-##']" class="with-border" type="tel" v-model="form.doc" placeholder="___.___.___-__" />
                                                </div>
                                            </div>

<!--                                             <div class="col-xl-6 col-lg-8 col-md-8" v-if="form.tipo == 'Pessoa Jurídica'">
                                                <div class="submit-field">
                                                    <h5>Nome:</h5>
                                                    <input type="text" class="with-border" placeholder="Nome fantasia" v-model="form.nome">
                                                </div>
                                            </div> -->

                                            <div class="col-xl-6 col-lg-8 col-md-8" v-if="form.tipo == 'Pessoa Física'">
                                                <div class="submit-field">
                                                    <h5>Nome:</h5>
                                                    <input type="text" class="with-border" placeholder="Nome completo" v-model="form.nome">
                                                </div>
                                            </div>                                            

                                            <div class="col-xl-6 col-lg-8 col-md-8" v-if="form.tipo == 'Pessoa Jurídica'">
                                                <div class="submit-field">
                                                    <h5>Razão social:</h5>
                                                    <input type="text" class="with-border" style="text-transform: uppercase !important;" placeholder="Razão social da empresa" v-model="form.razaoSocial">
                                                </div>
                                            </div>

                                            <div class="col-xl-4 col-xs-10 col-md-5 col-lg-5" v-if="form.tipo == 'Pessoa Física'">
                                                <div class="submit-field">
                                                    <h5>RG:</h5>
                                                    <the-mask :mask="['XXXXXXXXXXXX']" class="with-border" type="text" v-model="form.rg" placeholder="_________" />
                                                </div>
                                            </div>                                                                                        

                                            <div class="col-xl-4 col-md-5 col-lg-5">
                                                <div class="submit-field">
                                                    <h5>
                                                        Inscrição estadual:
                                                        <div class="checkbox">
                                                            <input type="checkbox" id="termos" v-model="form.inscricaoEstadual" true-value="Isenta" false-value="">
                                                            <label for="termos"><span class="checkbox-icon"></span>  Isenta</label>
                                                            <div class="hidden-lg hidden-xl hidden-md hidden-sm margin-top-5"></div>
                                                        </div>                                                        
                                                    </h5>
                                                    <input type="text" class="with-border" placeholder="" v-model="form.inscricaoEstadual" v-bind:class="{'disabled': form.inscricaoEstadual == 'Isenta'}">
                                                </div>
                                            </div>
                                                         

                                            <div class="col-xl-6 col-lg-6 col-md-6" v-for="(item, index) in form.email">
                                                <div class="submit-field">
                                                    <h5>
                                                        E-mail{{ ' (' + (index+1) + ')'}}:
                                                        <a v-on:click="delEmail(index)" v-if="index > 0">
                                                            <i class="material-icons">close</i>
                                                        </a>
                                                    </h5>
                                                    <input type="email" class="with-border" placeholder="Informe o e-mail aqui" v-model="form.email[index]">
                                                </div>
                                            </div>
                                            <div class="col-xs-12 hidden-lg hidden-xl hidden-md hidden-sm margin-top-5"></div>
                                            <div class="col-xl-12" style="margin-top: -15px; margin-bottom: 20px;">
                                                <button type="button" class="button gray small" v-on:click="addEmail">
                                                    <i class="material-icons">add</i>
                                                    Adicionar e-mail
                                                </button>
                                            </div>                                                                                                                                     

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-xl-12">
                                <div class="dashboard-box">

                                    <!-- Headline -->
                                    <div class="headline">
                                        <h3><i class="material-icons">place</i> Endereço</h3>
                                    </div>

                                    <div class="content with-padding padding-bottom-0">
                                        <div class="row">
                                            <div class="col-xl-10 col-lg-10 col-md-10">
                                                <div class="submit-field">
                                                    <h5>Rua:</h5>
                                                    <input type="text" class="with-border" placeholder="Endereço" v-model="form.endereco">
                                                </div>
                                            </div>

                                            <div class="col-xl-2 col-xs-5 col-lg-2 col-md-2">
                                                <div class="submit-field">
                                                    <h5>Número:</h5>
                                                    <input type="tel" class="with-border" placeholder="" v-model="form.numero">
                                                </div>
                                            </div>

                                            <div class="col-xl-9 col-xs-12">
                                                <div class="submit-field">
                                                    <h5>Complemento:</h5>
                                                    <input type="text" class="with-border" placeholder="" v-model="form.complemento">
                                                </div>
                                            </div>
                                    
                                            <div class="col-xl-3 col-xs-7 col-lg-4 col-md-4">
                                                <div class="submit-field">
                                                    <h5>CEP:</h5>
                                                    <the-mask :mask="['#####-###']" :masked="true" type="tel" class="with-border" v-model="form.cep" placeholder="Informe o CEP" />
                                                </div>
                                            </div>
                                    
                                            <div class="col-xl-4 col-lg-6 col-md-6">
                                                <div class="submit-field">
                                                    <h5>Bairro:</h5>
                                                    <input type="text" class="with-border" placeholder="Informe o bairro" v-model="form.bairro">
                                                </div>
                                            </div>

                                            <div class="col-xl-4 col-lg-6 col-md-6">
                                                <div class="submit-field">
                                                    <h5>Cidade:</h5>
                                                    <input type="text" class="with-border" id="cidade" placeholder="Informe a cidade" v-model="form.cidade">
                                                </div>
                                            </div>

                                            <div class="col-xl-4 col-lg-6 col-md-6">
                                                <div class="submit-field">
                                                    <h5>Estado:</h5>
                                                    <select id="estado" readonly="" class="with-border" name="estado" required="" v-model="form.estado" style="text-transform: uppercase;">
                                                        <option value="" disabled selected hidden>Selecione o estado</option>
                                                        <option value="AC">Acre</option>
                                                        <option value="AL">Alagoas</option>
                                                        <option value="AP">Amapá</option>
                                                        <option value="AM">Amazonas</option>
                                                        <option value="BA">Bahia</option>
                                                        <option value="CE">Ceará</option>
                                                        <option value="DF">Distrito Federal</option>
                                                        <option value="ES">Espírito Santo</option>
                                                        <option value="GO">Goiás</option>
                                                        <option value="MA">Maranhão</option>
                                                        <option value="MT">Mato Grosso</option>
                                                        <option value="MS">Mato Grosso do Sul</option>
                                                        <option value="MG">Minas Gerais</option>
                                                        <option value="PA">Pará</option>
                                                        <option value="PB">Paraíba</option>
                                                        <option value="PR">Paraná</option>
                                                        <option value="PE">Pernambuco</option>
                                                        <option value="PI">Piauí</option>
                                                        <option value="RJ">Rio de Janeiro</option>
                                                        <option value="RN">Rio Grande do Norte</option>
                                                        <option value="RS">Rio Grande do Sul</option>
                                                        <option value="RO">Rondônia</option>
                                                        <option value="RR">Roraima</option>
                                                        <option value="SC">Santa Catarina</option>
                                                        <option value="SP">São Paulo</option>
                                                        <option value="SE">Sergipe</option>
                                                        <option value="TO">Tocantins</option>
                                                    </select>                                                   
                                                </div>
                                            </div>
                                        
                                        </div>
                                    </div>                                                                      
                                </div>
                            </div>  

        


                            <div class="col-xl-12">
                                <div class="dashboard-box">
                                    <div class="content with-padding padding-bottom-0">
                                        <div class="row">
                                            <div class="col-xl-3 col-xs-8 col-md-4 col-lg-4">
                                                <div class="submit-field">
                                                    <h5>Telefone (1):</h5>
                                                    <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="with-border" placeholder="(__) _____-____" v-model="form.telefone[0]" />
                                                </div>
                                            </div>

                                            <div class="col-xl-3 col-xs-8 col-md-4 col-lg-4">
                                                <div class="submit-field">
                                                    <h5>Telefone (2):</h5>
                                                    <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="with-border" placeholder="(__) _____-____" v-model="form.telefone[1]" />
                                                </div>
                                            </div>    

                                            <div class="col-xl-3 col-xs-8 col-md-4 col-lg-4">
                                                <div class="submit-field">
                                                    <h5>Telefone (3):</h5>
                                                    <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="with-border" placeholder="(__) _____-____" v-model="form.telefone[2]" />
                                                </div>
                                            </div>       

                                            <div class="col-xl-3 col-xs-8 col-md-4 col-lg-4">
                                                <div class="submit-field">
                                                    <h5>Celular:</h5>
                                                    <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="with-border" placeholder="(__) _____-____" v-model="form.celular" />
                                                </div>
                                            </div>                                     
                                        </div>                                     
                                    </div>
                                    <!-- Headline -->
                                    <div class="headline" style="display: block !important;">
                                        <h3><i class="material-icons">attach_money</i> Contato financeiro</h3>
                                    </div>

                                    <div class="content with-padding padding-bottom-0">

                                        <div class="row">
                                            <div class="col-xl-6 col-md-6 col-lg-6">
                                                <div class="submit-field">
                                                    <h5>Nome:</h5>
                                                    <input type="text" class="with-border" placeholder="Informe o nome.." v-model="form.financeiroNome">
                                                </div>
                                            </div>

                                            <div class="col-xl-3 col-xs-8 col-md-6 col-lg-6">
                                                <div class="submit-field">
                                                    <h5>Telefone:</h5>
                                                    <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="with-border" placeholder="(__) _____-____" v-model="form.financeiroTelefone" />
                                                </div>
                                            </div>

                                        </div>
                                    </div>                                                                      
                                </div>
                            </div> 


                            <div class="col-xl-12">
                                <div class="dashboard-box">

                                    <!-- Headline -->
                                    <div class="headline" style="display: block !important;">
                                        <h3><i class="material-icons">insert_drive_file</i> Envio de ordens</h3>
                                    </div>

                                    <div class="content with-padding padding-bottom-0">

                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="checkbox margin-bottom-10">
                                                    <input type="checkbox" id="checkbox-ordens-pdf-whatsapp" v-model="form.enviarOrdemWhatsapp" true-value="1" false-value="0">
                                                    <label for="checkbox-ordens-pdf-whatsapp"><span class="checkbox-icon"></span> Enviar ordens para o WhatsApp abaixo:</label>
                                                </div>
                                            </div>

                                            <div class="col-xl-6 col-lg-6 col-md-6 col-xs-6" v-for="(item, index) in form.destinatarioOrdemWhatsapp">
                                                <div class="submit-field">
                                                    <h5>
                                                        WhatsApp{{ ' (' + (index+1) + ')'}}:
                                                        <a v-on:click="delDestinatarioOrdemWhatsapp(index)" v-if="index > 0">
                                                            <i class="material-icons">close</i>
                                                        </a>
                                                    </h5>
                                                  <the-mask style="padding: 0px; padding-left: 10px;" :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="with-border" placeholder="(__) _____-____" v-model="form.destinatarioOrdemWhatsapp[index]" />
                                                    <!-- <input type="email" class="with-border" placeholder="Informe o e-mail aqui" v-model="form.destinatarioOrdemEmail[index]"> -->
                                                </div>
                                            </div>      

                                            <div class="col-xs-12 hidden-lg hidden-xl hidden-md hidden-sm margin-top-5"></div>
                                            <div class="col-xl-12" style="margin-top: -15px; margin-bottom: 35px;">
                                                <button type="button" class="button gray small" v-on:click="addDestinatarioOrdemWhatsapp">
                                                    <i class="material-icons">add</i>
                                                    Adicionar WhatsApp
                                                </button>
                                            </div>


                                            <div class="col-lg-12">
                                                <div class="checkbox margin-bottom-10">
                                                    <input type="checkbox" id="checkbox-ordens-pdf-email" v-model="form.enviarOrdemEmail" true-value="1" false-value="0">
                                                    <label for="checkbox-ordens-pdf-email"><span class="checkbox-icon"></span> Enviar ordens em PDF para o(s) email(s) abaixo:</label>
                                                </div>
                                            </div>

                                            <div class="col-xl-6 col-lg-6 col-md-6" v-for="(item, index) in form.destinatarioOrdemEmail">
                                                <div class="submit-field">
                                                    <h5>
                                                        E-mail{{ ' (' + (index+1) + ')'}}:
                                                        <a v-on:click="delDestinatarioOrdemEmail(index)" v-if="index > 0">
                                                            <i class="material-icons">close</i>
                                                        </a>
                                                    </h5>
                                                    <input type="email" class="with-border" placeholder="Informe o e-mail aqui" v-model="form.destinatarioOrdemEmail[index]">
                                                </div>
                                            </div>      

                                            <div class="col-xs-12 hidden-lg hidden-xl hidden-md hidden-sm margin-top-5"></div>
                                            <div class="col-xl-12" style="margin-top: -15px; margin-bottom: 20px;">
                                                <button type="button" class="button gray small" v-on:click="addDestinatarioOrdemEmail">
                                                    <i class="material-icons">add</i>
                                                    Adicionar e-mail
                                                </button>
                                            </div>

                                        </div>


                                    </div>                                                                      
                                </div>
                            </div>                              

                            <div class="col-xl-12">
                                <div class="hidden-xs clearfix margin-top-30"></div>
                                <button type="submit" class="button ripple-effect big block-mobile" v-bind:class="{'disabled': loading.submit }">
                                    <i class="material-icons">save</i>
                                    {{ form.cod ? 'Salvar cliente' : 'Cadastrar cliente' }}
                                </button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                               'GerenciarClientes',
    components: {
        'Top':                          Top,
        'Sidebar':                      Sidebar,
        'Toolbar':                      Toolbar
    },      
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },      
    data () {
        return {
            "loading": {
                "submit":               false
            },
            "form": {
                "_cod":                 "",
                "_token":               "",
                "nome":                 "",
                "tipo":                 "Pessoa Jurídica",
                "razaoSocial":          "",
                "celular":              "",
                "email":                [
                    "",
                    ""
                ],
                "telefone":             [
                    "",
                    "",
                    ""
                ],
                "rg":                   "",
                "doc":                  "",
                "endereco":             "",
                "numero":               "",
                "complemento":          "",
                "cep":                  "",
                "bairro":               "",
                "cidade":               "",
                "estado":               "",
                "financeiroNome":       "",
                "financeiroTelefone":   "",
                "enviarOrdemWhatsapp":  0,
                "destinatarioOrdemWhatsapp":  "",
                "enviarOrdemEmail":     0,
                "suspenso":             0,
                "dividas":              0,
                "destinatarioOrdemEmail":[],
                "destinatarioOrdemWhatsapp":[]
            }            
        }
    },
    methods: {
        addEmail: function() {
            console.log("addEmail()");
            var self = this;
            self.form.email.push("");
        },
        delEmail: function(i) {
            console.log("delEmail()", i)
            var self = this;
            self.form.email.splice(i, 1);
        },
        addDestinatarioOrdemEmail: function() {
            console.log("addDestinatarioOrdemEmail()");
            var self = this;
            self.form.destinatarioOrdemEmail.push("");
        },
        delDestinatarioOrdemEmail: function(i) {
            console.log("delDestinatarioOrdemEmail()", i)
            var self = this;
            self.form.destinatarioOrdemEmail.splice(i, 1);
        },      
        addDestinatarioOrdemWhatsapp: function() {
            console.log("addDestinatarioOrdemWhatsapp()");
            var self = this;
            self.form.destinatarioOrdemWhatsapp.push("");
        },
        delDestinatarioOrdemWhatsapp: function(i) {
            console.log("delDestinatarioOrdemWhatsapp()", i)
            var self = this;
            self.form.destinatarioOrdemWhatsapp.splice(i, 1);
        },                
        submit: function(e) {
            var self            = this;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            var a = "post";
            if (self.form.cod) {
                a = "put";
            }

            axios[a]("api/clientes.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                alert(response.data.message);
                self.$root.back();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        getDB: function() {
            console.log("getDB()");
            var self = this;
            return new Promise(function(resolve, reject) {
                self.$root.db["clientes"].query(function(doc) {
                    if (doc.request.all) {
                        emit(doc);
                    }
                }, {include_docs : true}).then(function (result) {
                    console.log("clientes find()", "ok:", result);
                    
                    var item = result.rows[0].doc.result.result.itens.filter(function(item) {
                        if (item.cod == self.form.cod) return item;
                    })[0] || null;
                    
                    loading.hide();

                    console.log("Setou cliente:", item)
                    resolve(item)

                }).catch(function (err) {
                    console.log("clientes find()", "erro:", err);
                    resolve(err);
                });              
            });              
        },         
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                if (!self.$root.internet.online) {
                    console.log("Não está online, busca offline")
                    self.getDB().then(function(result) {
                        console.log("result", result);
                        if (result) {
                            self.form   = result;
                            self.loaded = true;
                        } else {

                        }
                    }).catch(function(error) {
                        console.log("catch", error);
                    });

                } else {                    
                    var form = {
                        "params": {
                            "_cod":         self.$root.user.cod, 
                            "_token":       self.$root.user.token,
                            "cod":          self.form.cod
                        }
                    };

                    axios.get("api/clientes.php", form)
                    .then(response => {
                        
                        console.log("get() response", response);

                        self.form           = response.data.result;

                        if (!self.form.destinatarioOrdemWhatsapp) {
                            self.form.destinatarioOrdemWhatsapp = [];
                        }

                        self.loaded         = true;
                        loading.hide();
                        resolve(response.data.result);
      
                    })
                    .catch(error => {
                        console.log("get() error", error);                    
                        loading.hide();
                        reject(error);
                        alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                        if (error.response) {
                            if (error.response.status == 404) {
                                self.$root.back();
                            }
                        }                    
                    });   
                }
            });   
        }           
    },    
    created: function() {
        var self = this;
        console.log("created", self);

        if (self.$route.name == "EditarClientes") {
            if (!self.$route.query.c) {
                self.$root.back();
                return false;
            }
            self.form.cod = self.$route.query.c;
            self.get();
        } else {
            loading.hide();
        }

    },
    mounted: function() {
    }   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/GerenciarClientes.vue